import axios from "axios";
import MockAdapter from "axios-mock-adapter";
import { log } from "../utils/logger";
import { isLocal } from "../utils/env";

if (isLocal) {
  const MOCK_CALLS: string[] = [
    "sample",
    // "auth",
    // "auth.sso",
    // "auth.client-portal-token",
    "account",
    "contactMethods",
  ];

  log("%cSetting up mock calls", "color: green; font-weight: bold;");

  // This sets the mock adapter on the default instance
  const mock = new MockAdapter(axios);

  if (MOCK_CALLS.includes("sample")) {
    // Reply with error on first attempt, then reply with success
    mock
      // Error on first attempt
      .onAny("/sample")
      .replyOnce(500, { status: "error", error: "Landing error" })
      // Successful on subsequent attempt
      .onAny("/sample")
      .reply(200, {
        status: "success",
        sample: require("./generateSample").default(50),
      });

    // Advanced: URI with variables
    mock.onAny(/sample\/*/).reply((config) => {
      let match = config.url && /dataset\/filter\/(.+)/.exec(config.url);
      const parse_url = match && match[1];

      return [200, { status: "success", options: parse_url }];
    });
  }

  if (MOCK_CALLS.includes("auth")) {
    // LOAD USER
    mock
      .onGet("user") // User API
      .reply(200, require("./lib/auth.user"));

    if (MOCK_CALLS.includes("auth.sso")) {
      mock
        .onAny("auth/sso") // SSO Authentication
        .reply(require("./lib/auth.sso"));
    }

    if (MOCK_CALLS.includes("auth.client-portal-token")) {
      mock
        .onGet("auth/client-portal-token") // iFrame Authentication Page => Account Verification API
        .reply(200, require("./lib/auth.client-portal-token"));
    }
  }

  if (MOCK_CALLS.includes("account")) {
    mock.onGet(/account\/[\w]+$/).reply(require("./lib/account.get").default);
  }

  if (MOCK_CALLS.includes("contactMethods")) {
    mock
      .onGet(/contact\/[\w]+$/)
      .reply(require("./lib/contactMethods").getContactMethods)
      .onPost(/contact\/[\w]+$/)
      .reply(require("./lib/contactMethods").createContactMethod);
  }

  // Forward unmatched APIs through the network
  mock.onAny().passThrough();
}
